import React, { useState } from 'react';
import { Dropdown, Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { getUserData } from '../utils/util';
import UserProfileModal from './UserProfileModal';
import UserSettingsModal from './UserSettingsModal';

const UserDropdown = ({ onLogout }) => {
  const [showProfile, setShowProfile] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const user = getUserData() || {};
  const getRoleLabel = (rol) => {
    switch(String(rol)) {
      case '99': return 'Master';
      case '1': return 'Admin';
      case '2': return 'Contador';
      case '3': return 'Cajero';
      case '4': return 'Vendedor';
      default: return rol ? 'Desconocido' : 'N/A';
    }
  };
  const roleLabel = getRoleLabel(user.rol);

  const renderTooltip = (text) => (props) => (
    <Tooltip {...props}>{text}</Tooltip>
  );

  return (
    <>
      <Dropdown>
        <Dropdown.Toggle variant="transparent" title="Ajustes" className='text-white d-flex align-items-center gap-2'>
          <Badge bg={String(user.rol) === '99' ? 'warning' : String(user.rol) === '1' ? 'danger' : String(user.rol) === '2' ? 'success' : String(user.rol) === '3' ? 'info' : String(user.rol) === '4' ? 'warning' : 'secondary'} pill className="ms-1">{roleLabel}</Badge>
        </Dropdown.Toggle>
        <Dropdown.Menu align="end" className="shadow rounded-3 p-2">
          <OverlayTrigger placement="left" overlay={renderTooltip('Ver tu información personal y de la empresa')}>
            <Dropdown.Item onClick={() => setShowProfile(true)} className="d-flex align-items-center gap-2">
              <i className="fa fa-user text-primary" aria-hidden="true"></i>
              <span>Perfil</span>
            </Dropdown.Item>
          </OverlayTrigger>
          <OverlayTrigger placement="left" overlay={renderTooltip('Configura tu experiencia y preferencias')}>
            <Dropdown.Item onClick={() => setShowSettings(true)} className="d-flex align-items-center gap-2">
              <i className="fa fa-cog text-secondary" aria-hidden="true"></i>
              <span>Ajustes</span>
            </Dropdown.Item>
          </OverlayTrigger>
          <Dropdown.Divider />
          <OverlayTrigger placement="left" overlay={renderTooltip('Cerrar sesión')}>
            <Dropdown.Item onClick={onLogout} className="d-flex align-items-center gap-2 text-danger">
              <i className="fa fa-sign-out" aria-hidden="true"></i>
              <span>Salir</span>
            </Dropdown.Item>
          </OverlayTrigger>
        </Dropdown.Menu>
      </Dropdown>
      <UserProfileModal show={showProfile} onHide={() => setShowProfile(false)} />
      <UserSettingsModal show={showSettings} onHide={() => setShowSettings(false)} />
    </>
  );
};

export default UserDropdown;
